<div [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
    [showSpinner]="loading"
    size="small"
    [disableAnimation]="false"
    name="instructionalPeriodSpinner"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="false"
    [zIndex]="1003"
  >
  </ngx-spinner>
  <div class="row">
    <div class="col-md-4">
      <img
        src="/assets/images/RespondEDU-Logo-Colored.svg"
        alt="logo-img"
        height="100"
        width="200"
        style="border-radius: 50%"
        *ngIf="!isManageSchoolYear && isAdminiStration"
      />
    </div>
    <div class="col-md-4 d-flex justify-content-center">
      <div *ngIf="isAdminiStration" class="w-100">
        <ngx-form-stepper [manageSchoolYear]="isManageSchoolYear"></ngx-form-stepper>
      </div>
    </div>
    <div class="col-md-4"></div>
  </div>

  <div class="trial-period-message mb-4" *ngIf="isAdminiStration && user?.user?.is_trial_user">
    <label class="quicksand-bold-label trial-period-label"> Trial Period Users: </label>
    <label class="quicksand-normal-label trial-message"
      >This is where you, as an administrator, would normally set up your school’s bell schedules. For your trial period demo, it is all
      filled out for you so you can get to your demo portal straight-away! Click “Next” to continue.</label
    >
  </div>
  <div style="position: absolute; right: 3rem; top: 25%">
    <button
      nbButton
      color="warn"
      class="next cursor-pointer quicksand-bold-label"
      (click)="submit()"
      *ngIf="isAdminiStration && user?.user?.is_trial_user"
    >
      Next
    </button>
  </div>
  <!--  used isManageSchoolYear flag to hide logo  -->
  <div
    [ngClass]="{
      'card-padding': isAdminiStration && !isManageSchoolYear,
    }"
  >
    <div
      [ngClass]="{
        row: !isAdminiStration,
      }"
    >
      <div
        class="col-md-12 d-flex justify-content"
        [ngClass]="{
          header: isAdminiStration,
        }"
      >
        <div *ngIf="isAdminiStration">
          <h5 class="quicksand-bold-label text-dark mb-0 instruct-period" [ngClass]="user && user.user.role_id === 19 ? 'mt-4' : ''">
            School Instructional Periods
          </h5>
        </div>
        <div *ngIf="!isAdminiStration">
          <h5 class="quicksand-bold-label text-dark mb-0 instruct-period" [ngClass]="user && user.user.role_id === 19 ? 'mt-4' : ''">
            School Instructional Periods
          </h5>
          <span class="quicksand-normal-label span-label dark-mode-label-color"> School information and bell schedule </span>
        </div>
      </div>
      <div class="d-flex justify-content-between" [ngClass]="title === 'teacherNewAcademicYearSetup' ? 'ml-auto' : ''">
        <span
          class="quicksand-normal-label span-label dark-mode-label-color sub-header-administration"
          *ngIf="isAdminiStration"
          style="padding: 16px"
        >
          School information and bell schedule
          <span>(this will be a one time process to create a schedule, please add it carefully)</span>
        </span>

        <button
          nbButton
          color="primary"
          class="save-and-next-btn quicksand-bold-label text-capitalize text-white cursor-pointer mr-4"
          (click)="router.url.includes('teacher') ? saveTeacherShedule(dialog) : submit(true)"
          [disabled]="user?.user?.is_trial_user"
          *ngIf="isAdminiStration || isManageSchoolYear || title === 'teacherNewAcademicYearSetup'"
        >
          Save and Next
        </button>
      </div>
    </div>
    <hr class="hr-color" />
    <div class="instructional-periods">
      <div
        class="container-fluid"
        [ngClass]="{
          'instructional-period-content': !isAdminiStration,
        }"
      >
        <div class="row mb-4" *ngIf="isAdminiStration || title === 'teacherNewAcademicYearSetup'">
          <div class="col-md-12 d-flex justify-content-between">
            <div class="quicksand-bold-label pt-3">
              Please create your weekly bell schedule below. This will be used in the generation of academic instructional periods for
              <span *ngIf="isAdminiStration && !router.url.includes('teacher')"> Teachers.</span>
              <span *ngIf="(isAdminiStration && router.url.includes('teacher')) || isTeacherManagement">you.</span>
            </div>
            <div class="float-right">
              <button
                nbButton
                color="primary"
                class="add-school-periods-btn w-auto quicksand-bold-label text-capitalize text-white mr-2 dark-mode-label-color"
                (click)="openSchoolBellSchedulesModal()"
                *ngIf="isAdminiStration && !router.url.includes('teacher') && schools?.length > 0"
              >
                Select bell schedule from Schools
              </button>

              <button
                nbButton
                color="primary"
                class="add-school-periods-btn create-bell-schedule quicksand-bold-label text-capitalize text-white mr-2"
                (click)="isEdit = false; openSchoolPeriodModal(selectBellSheduleTypeModal)"
                [disabled]="user?.user?.is_trial_user"
              >
                Create Bell Schedule
              </button>
            </div>
          </div>
        </div>

        <form [formGroup]="schoolForm">
          <div class="row">
            <div class="col-md-6" *ngIf="!isTeacherOnly">
              <div class="form-group">
                <label>School Name</label>
                <input type="text" nbInput class="form-control disabled-input" id="name" formControlName="name" readonly />
              </div>
            </div>

            <div class="col-md-6" *ngIf="!isTeacherOnly">
              <div class="form-group">
                <label>School Code</label>
                <input type="text" nbInput class="form-control disabled-input" id="code" formControlName="code" readonly />
              </div>
            </div>

            <div class="col-md-6" *ngIf="!isTeacherOnly">
              <div class="form-group">
                <label>Country <span class="required-field">*</span></label>
                <input
                  type="text"
                  nbInput
                  class="form-control"
                  id="country"
                  formControlName="country"
                  maxlength="100"
                  [readOnly]="!isAdminiStration || router.url.includes('teacher') || isManageSchoolYear"
                  [ngClass]="{
                    'disabled-input': !isAdminiStration || router.url.includes('teacher') || isManageSchoolYear,
                  }"
                />

                <label
                  class="quicksand-bold-label error-label"
                  *ngIf="schoolForm.controls.country.invalid && (schoolForm.controls.country.dirty || schoolForm.controls.country.touched)"
                  >Enter Valid Country Name</label
                >
              </div>
            </div>

            <div class="col-md-6" *ngIf="!isTeacherOnly">
              <div class="form-group">
                <label>State <span class="required-field">*</span></label>
                <input
                  type="text"
                  nbInput
                  class="form-control"
                  id="state"
                  formControlName="state"
                  maxlength="100"
                  [readOnly]="!isAdminiStration || router.url.includes('teacher') || this.isManageSchoolYear"
                  [ngClass]="{
                    'disabled-input': !isAdminiStration || router.url.includes('teacher') || this.isManageSchoolYear,
                  }"
                />
                <label
                  class="quicksand-bold-label error-label"
                  *ngIf="schoolForm.controls.state.invalid && (schoolForm.controls.state.dirty || schoolForm.controls.state.touched)"
                  >Enter Valid State Name</label
                >
              </div>
            </div>

            <div class="col-md-6" *ngIf="!isTeacherOnly">
              <div class="form-group">
                <label>City <span class="required-field">*</span></label>
                <input
                  type="text"
                  nbInput
                  class="form-control"
                  id="city"
                  formControlName="city"
                  maxlength="100"
                  [readOnly]="!isAdminiStration || router.url.includes('teacher') || isManageSchoolYear"
                  [ngClass]="{
                    'disabled-input': !isAdminiStration || router.url.includes('teacher') || isManageSchoolYear,
                  }"
                />
                <label
                  class="quicksand-bold-label error-label"
                  *ngIf="schoolForm.controls.city.invalid && (schoolForm.controls.city.dirty || schoolForm.controls.city.touched)"
                  >Enter Valid City Name</label
                >
              </div>
            </div>

            <div class="col-md-6" *ngIf="!isTeacherOnly">
              <div class="form-group">
                <label>Phone <span class="required-field">*</span></label>
                <input
                  type="text"
                  nbInput
                  class="form-control"
                  id="address"
                  formControlName="phone"
                  mask="(000) 000-0000"
                  [readOnly]="!isAdminiStration || router.url.includes('teacher') || isManageSchoolYear"
                  [ngClass]="{
                    'disabled-input': !isAdminiStration || router.url.includes('teacher') || isManageSchoolYear,
                  }"
                />
                <label
                  class="quicksand-bold-label error-label"
                  *ngIf="schoolForm.controls.phone.invalid && (schoolForm.controls.phone.dirty || schoolForm.controls.phone.touched)"
                  >Enter Valid Phone Number</label
                >
              </div>
            </div>

            <ng-container *ngIf="!router.url.includes('teacher') && (router.url.includes('administration') || isManageSchoolYear)">
              <div class="col-md-6">
                <div class="form-group">
                  <label>First Day of School <span class="required-field">*</span></label>

                  <input
                    nbInput
                    placeholder="Enter School Start Date"
                    formControlName="startDate"
                    [nbDatepicker]="dateTimePickerStartDate"
                    [ngClass]="{
                      'disabled-input': !isAdminiStration,
                    }"
                  />
                  <!-- [readOnly]="!isAdminiStration && !isTeacherOnly" -->
                  <nb-datepicker #dateTimePickerStartDate></nb-datepicker>
                  <label
                    class="quicksand-bold-label error-label"
                    *ngIf="
                      schoolForm.controls.startDate.invalid &&
                      (schoolForm.controls.startDate.dirty || schoolForm.controls.startDate.touched)
                    "
                    >Enter School Start Date
                  </label>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>Last Day of School <span class="required-field">*</span></label>

                  <input
                    type="text"
                    readonly
                    placeholder="Enter School End Date"
                    class="bg-transparent"
                    *ngIf="!schoolForm.value.startDate"
                    [readOnly]="!isAdminiStration || !isTeacherOnly"
                    [ngClass]="{
                      'disabled-input': !isAdminiStration,
                    }"
                  />

                  <input
                    nbInput
                    *ngIf="schoolForm.value.startDate"
                    placeholder="Enter End Date"
                    formControlName="endDate"
                    [nbDatepicker]="dateTimePickerEndDate"
                    [readOnly]="!isAdminiStration && !isTeacherOnly"
                    [ngClass]="{
                      'disabled-input': !isAdminiStration,
                    }"
                  />
                  <nb-datepicker #dateTimePickerEndDate [min]="schoolForm.value.startDate"></nb-datepicker>
                  <label
                    class="quicksand-bold-label error-label"
                    *ngIf="
                      schoolForm.controls.endDate.invalid && (schoolForm.controls.endDate.dirty || schoolForm.controls.endDate.touched)
                    "
                    >Enter end date must be later than the start date
                  </label>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >School Day Start Time
                    <span class="required-field">*</span>
                  </label>

                  <input
                    nbInput
                    type="text"
                    [nbTimepicker]="timepickerStartTime"
                    formControlName="startTime"
                    placeholder="Enter School Start Time"
                    [readOnly]="!isAdminiStration && !isTeacherOnly"
                    [ngClass]="{
                      'disabled-input': !isAdminiStration,
                    }"
                  />
                  <nb-timepicker #timepickerStartTime="nbTimepicker" twelveHoursFormat></nb-timepicker>
                  <label
                    class="quicksand-bold-label error-label"
                    *ngIf="
                      schoolForm.controls.startTime.invalid &&
                      (schoolForm.controls.startTime.dirty || schoolForm.controls.startTime.touched)
                    "
                    >Enter School Start Time
                  </label>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >School Day End Time
                    <span class="required-field">*</span>
                  </label>
                  <input
                    type="text"
                    readonly
                    *ngIf="!schoolForm.value.startTime"
                    class="bg-transparent"
                    placeholder="Enter School End Time"
                    [readOnly]="!isAdminiStration && !isTeacherOnly"
                    [ngClass]="{
                      'disabled-input': !isAdminiStration,
                    }"
                  />
                  <input
                    nbInput
                    type="text"
                    [nbTimepicker]="timepickerEndTime"
                    *ngIf="schoolForm.value.startTime"
                    formControlName="endTime"
                    placeholder="Enter School End Time"
                    [readOnly]="!isAdminiStration"
                    [ngClass]="{
                      'disabled-input': !isAdminiStration,
                    }"
                    [min]="schoolForm.value.startTime"
                  />
                  <nb-timepicker #timepickerEndTime="nbTimepicker" twelveHoursFormat></nb-timepicker>
                  <label
                    class="quicksand-bold-label error-label"
                    *ngIf="
                      schoolForm.controls.endTime.invalid && (schoolForm.controls.endTime.dirty || schoolForm.controls.endTime.touched)
                    "
                    >Enter end time must be later than the start time
                  </label>
                </div>
              </div>

              <!-- show calendar name input only when user is managing school year  -->
              <div class="col-md-6" *ngIf="isManageSchoolYear">
                <div class="form-group">
                  <label> Calendar Name </label>
                  <input
                    type="text"
                    nbInput
                    class="form-control"
                    id="calendar_title"
                    formControlName="calendar_title"
                    placeholder="Enter School Calendar Name"
                    maxlength="50"
                    [readOnly]="!isAdminiStration || router.url.includes('teacher')"
                    [ngClass]="{
                      'disabled-input': !isAdminiStration || router.url.includes('teacher'),
                    }"
                  />
                  <label
                    class="quicksand-bold-label error-label"
                    *ngIf="
                      schoolForm.controls.calendar_title.invalid &&
                      (schoolForm.controls.calendar_title.dirty || schoolForm.controls.calendar_title.touched)
                    "
                    >Enter Valid School Calendar Title</label
                  >
                </div>
              </div>
            </ng-container>

            <ng-container
              *ngIf="
                (router.url.includes('teacher') && !isTeacherOnly) ||
                (!router.url.includes('administration') && !isManageSchoolYear && !isTeacherOnly)
              "
            >
              <div class="col-md-6">
                <div class="form-group">
                  <label>First Day of School</label>

                  <input
                    nbInput
                    placeholder="Enter School Start Date"
                    formControlName="startDate"
                    class="form-control disabled-input"
                    readonly
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>Last Day of School</label>

                  <input nbInput placeholder="Enter End Date" formControlName="endDate" class="form-control disabled-input" readOnly />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>School Day Start Time</label>
                  <!-- removed the un-necessary text from the placeholder -->
                  <input
                    nbInput
                    type="text"
                    formControlName="startTime"
                    class="form-control disabled-input"
                    placeholder="Enter School Start Time"
                    readOnly
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>School Day End Time</label>
                  <!-- removed the un-necessary text from the placeholder -->
                  <input
                    nbInput
                    type="text"
                    formControlName="endTime"
                    class="form-control disabled-input"
                    placeholder="Enter School End Time"
                    readOnly
                  />
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="router.url.includes('teacher') && router.url.includes('administration') && isTeacherOnly">
              <div class="col-md-6">
                <div class="form-group">
                  <label>First Day of School <span class="required-field">*</span></label>

                  <input
                    nbInput
                    placeholder="Enter School Start Date"
                    formControlName="startDate"
                    [nbDatepicker]="dateTimePickerStartDate"
                  />
                  <!-- [ngClass]="{
                      'disabled-input': !isAdminiStration
                    }" -->
                  <!-- [readOnly]="!isAdminiStration && !isTeacherOnly" -->
                  <nb-datepicker #dateTimePickerStartDate></nb-datepicker>
                  <label
                    class="quicksand-bold-label error-label"
                    *ngIf="
                      schoolForm.controls.startDate.invalid &&
                      (schoolForm.controls.startDate.dirty || schoolForm.controls.startDate.touched)
                    "
                    >Enter School Start Date
                  </label>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>Last Day of School <span class="required-field">*</span></label>

                  <input
                    type="text"
                    readonly
                    placeholder="Enter School End Date"
                    class="bg-transparent"
                    *ngIf="!schoolForm.value.startDate"
                    [readOnly]="!isAdminiStration || !isTeacherOnly"
                    [ngClass]="{
                      'disabled-input': !isAdminiStration,
                    }"
                  />

                  <input
                    nbInput
                    *ngIf="schoolForm.value.startDate"
                    placeholder="Enter End Date"
                    formControlName="endDate"
                    [nbDatepicker]="dateTimePickerEndDate"
                    [readOnly]="!isAdminiStration && !isTeacherOnly"
                    [ngClass]="{
                      'disabled-input': !isAdminiStration,
                    }"
                  />
                  <nb-datepicker #dateTimePickerEndDate [min]="schoolForm.value.startDate"></nb-datepicker>
                  <label
                    class="quicksand-bold-label error-label"
                    *ngIf="
                      schoolForm.controls.endDate.invalid && (schoolForm.controls.endDate.dirty || schoolForm.controls.endDate.touched)
                    "
                    >Enter School End Date
                  </label>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >School Day Start Time
                    <span class="required-field">*</span>
                  </label>

                  <input
                    nbInput
                    type="text"
                    [nbTimepicker]="timepickerStartTime"
                    formControlName="startTime"
                    placeholder="Enter School Start Time"
                    [readOnly]="!isAdminiStration && !isTeacherOnly"
                    [ngClass]="{
                      'disabled-input': !isAdminiStration,
                    }"
                  />
                  <nb-timepicker #timepickerStartTime="nbTimepicker" twelveHoursFormat></nb-timepicker>
                  <label
                    class="quicksand-bold-label error-label"
                    *ngIf="
                      schoolForm.controls.startTime.invalid &&
                      (schoolForm.controls.startTime.dirty || schoolForm.controls.startTime.touched)
                    "
                    >Enter School Start Time
                  </label>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label
                    >School Day End Time
                    <span class="required-field">*</span>
                  </label>
                  <input
                    type="text"
                    readonly
                    *ngIf="!schoolForm.value.startTime"
                    class="bg-transparent"
                    placeholder="Enter School End Time"
                    [readOnly]="!isAdminiStration && !isTeacherOnly"
                    [ngClass]="{
                      'disabled-input': !isAdminiStration,
                    }"
                  />
                  <input
                    nbInput
                    type="text"
                    [nbTimepicker]="timepickerEndTime"
                    *ngIf="schoolForm.value.startTime"
                    formControlName="endTime"
                    placeholder="Enter School End Time"
                    [readOnly]="!isAdminiStration"
                    [ngClass]="{
                      'disabled-input': !isAdminiStration,
                    }"
                    [min]="schoolForm.value.startTime"
                  />
                  <nb-timepicker #timepickerEndTime="nbTimepicker" twelveHoursFormat></nb-timepicker>
                  <label
                    class="quicksand-bold-label error-label"
                    *ngIf="
                      schoolForm.controls.endTime.invalid && (schoolForm.controls.endTime.dirty || schoolForm.controls.endTime.touched)
                    "
                    >Enter School End Time
                  </label>
                </div>
              </div>

              <!-- <div class="col-md-6">
                <div class="form-group">
                  <label> School Calendar Title</label>
                  <input
                    type="text"
                    nbInput
                    class="form-control"
                    id="calendar_title"
                    formControlName="calendar_title"
                    maxlength="50"
                    [readOnly]="
                      !isAdminiStration || router.url.includes('teacher')
                    "
                    [ngClass]="{
                      'disabled-input':
                        !isAdminiStration || router.url.includes('teacher')
                    }"
                  />
                  <label
                    class="quicksand-bold-label error-label"
                    *ngIf="
                      schoolForm.controls.calendar_title.invalid &&
                      (schoolForm.controls.calendar_title.dirty ||
                        schoolForm.controls.calendar_title.touched)
                    "
                    >Enter Valid School Calendar Title</label
                  >
                </div>
              </div> -->
            </ng-container>
          </div>
        </form>

        <div *ngIf="!router.url.includes('teacher')">
          <div *ngIf="school && bellShedules?.length > 0" class="mt-3">
            <div class="d-flex justify-content-between">
              <div class="form-group w-100">
                <h6 class="quicksand-bold-label">Select Bell Schedule</h6>

                <mat-select
                  placeholder="Please Select Bell Schedule"
                  (selectionChange)="getCurrentBellShedule($event.value)"
                  class="select-bell-shedule"
                  [(ngModel)]="currentBellShedule"
                >
                  <mat-option
                    *ngFor="let bellShedule of bellShedules; let i = index"
                    [value]="bellShedule"
                    class="quicksand-bold-label select-range select-school-name"
                    ><span *ngIf="bellShedule?.name">
                      {{ bellShedule?.name }}
                    </span>
                    <span *ngIf="!bellShedule?.name">Version {{ i + 1 }}</span></mat-option
                  >
                </mat-select>
              </div>

              <div class="delete pt-5 d-flex" *ngIf="isAdminiStration">
                <nb-icon
                  class="float-right cursor-pointer mt-3"
                  icon="edit-2-outline"
                  (click)="openEditBellScheduleNameModal()"
                  title="Update Bell Schedule Name"
                  [ngClass]="analyticsService?.currentTheme === 'material-light' ? 'edit-icon-light-theme' : 'edit-icon-dark-theme'"
                ></nb-icon>
                <span class="delete-pacing-plans ml-3 cursor-pointer" (click)="openDeletePlanModal()">
                  <img src="/assets/icons/delete.svg" alt="delete-icon" height="20" width="20" />
                </span>
              </div>
            </div>

            <label *ngIf="isAdminiStration" class="quicksand-bold-label mb-3"
              >You can edit instructional periods by clicking on edit icon below
            </label>
            <br />

            <div class="row" *ngIf="currentBellShedule?.school_id">
              <div class="col-md-6 col-xl-6 col-xxl-4" *ngFor="let schoolPeriod of currentBellShedule?.bell_schedule">
                <nb-card class="border-0">
                  <nb-card-header class="quicksand-bold-label text-uppercase school-period-card-header"
                    >{{ schoolPeriod.day | titlecase }}

                    <nb-icon
                      *ngIf="isAdminiStration"
                      class="edit-instructional-periods float-right cursor-pointer"
                      icon="edit-2-outline"
                      (click)="isEdit = true; editInstructionalPeriods(schoolPeriod)"
                      [ngClass]="analyticsService?.currentTheme === 'material-light' ? 'edit-icon-light-theme' : 'edit-icon-dark-theme'"
                    ></nb-icon>
                  </nb-card-header>
                  <nb-card-body
                    style="line-height: 1.5rem !important"
                    class="nb-body-dark"
                    [ngClass]="{
                      'card-background-administration': isAdminiStration,
                    }"
                  >
                    <div
                      class="row mt-2"
                      *ngFor="let period of schoolPeriod.periods; let i = index"
                      [ngClass]="
                        !period?.title?.toLowerCase().includes('period') && !period?.title?.toLowerCase().includes('block')
                          ? 'title-break'
                          : ''
                      "
                    >
                     <div class="col-4 col-sm-4 col-md-4 quicksand-bold-label text-break">
                        {{ period.title | titlecase }}
                      </div>
                      <div class="col-4 col-sm-4 col-md-4 quicksand-bold-label period-time">
                        {{ period.start | date: 'h:mm a' }}
                      </div>
                      <div class="col-4 col-sm-4 col-md-4 quicksand-bold-label period-time">
                        {{ period.end | date: 'h:mm a' }}
                      </div>
                    </div>
                  </nb-card-body>
                </nb-card>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="router.url.includes('teacher') && teacherSchoolPeriods && teacherSchoolPeriods[0]?.school_periods?.length > 0"
          class="mt-3"
        >
          <label *ngIf="isAdminiStration" class="quicksand-bold-label mb-3"
            >You can edit instructional periods by clicking on edit icon below
          </label>
          <br />
          <div class="row">
            <div class="col-md-4" *ngFor="let schoolPeriod of teacherSchoolPeriods[0]?.school_periods">
              <nb-card class="border-0">
                <nb-card-header class="quicksand-bold-label text-uppercase school-period-card-header"
                  >{{ schoolPeriod.day | titlecase }}

                  <nb-icon
                    *ngIf="isAdminiStration || title === 'teacherNewAcademicYearSetup'"
                    class="float-right cursor-pointer"
                    icon="edit-2-outline"
                    (click)="isEdit = true; editInstructionalPeriods(schoolPeriod)"
                    [ngClass]="analyticsService?.currentTheme === 'material-light' ? 'edit-icon-light-theme' : 'edit-icon-dark-theme'"
                  ></nb-icon>
                </nb-card-header>
                <nb-card-body style="line-height: 1.5rem !important">
                  <div
                    class="row mt-2"
                    *ngFor="let period of schoolPeriod.periods; let i = index"
                    [ngClass]="
                      !period?.title?.toLowerCase().includes('period') && !period?.title?.toLowerCase().includes('block')
                        ? 'title-break'
                        : ''
                    "
                  >
                    <div class="col-md-4 quicksand-bold-label">
                      {{ period.title | titlecase }}
                    </div>
                    <div class="col-md-4 quicksand-bold-label">
                      {{ period.start | date: 'h:mm a' }}
                    </div>
                    <div class="col-md-4 quicksand-bold-label">
                      {{ period.end | date: 'h:mm a' }}
                    </div>
                  </div>
                </nb-card-body>
              </nb-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #myModal let-modal>
  <div class="add-classroom-modal">
    <div class="modal-header d-flex justify-content-between align-items-center w-100">
      <div class="d-flex align-items-center">
        <span class="icon-add-classroom">
          <nb-icon icon="plus-outline"></nb-icon>
        </span>
        <h6 class="add-clasroom-text quicksand-bold-label m-0">
          <span *ngIf="!isEdit">Add</span>
          <span *ngIf="isEdit">Edit</span> Instructional Periods
        </h6>
      </div>

      <span
        class="icon-close-classroom-modal d-block cursor-pointer"
        (click)="modalService.dismissAll(modalRef); addSchoolPeriodForm.reset(); loading = false"
      >
        <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
      </span>
    </div>

    <div class="modal-body">
      <ng-container [ngTemplateOutlet]="newScheduleForm"></ng-container>
      <!-- <form [formGroup]="addSchoolPeriodForm">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group" *ngIf="!isEdit && selectedType === '2'">
            <label class="quicksand-normal-label label-color"
              >Name of Bell Schedule
            </label>
            <input
              type="text"
              nbInput
              formControlName="name"
              class="text-capitalize"
              placeholder="Please Enter Name"
              *ngIf="!isEdit"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <ng-container *ngIf="!isEdit">
              <label class="quicksand-normal-label label-color"
                >Select Days <span class="required-field">*</span></label
              >
              <mat-select
                multiple
                #sl
                formControlName="days"
                placeholder="Select Weekdays"
              >
                <mat-option
                  *ngFor="let day of weekDays"
                  [value]="day"
                  class="margin-filter-user"
                  >{{ day | titlecase }}</mat-option
                >
                <button
                  (click)="sl.close()"
                  mat-raised-button
                  class="float-right m-1 apply-button text-capitalize text-white quicksand-bold-label"
                >
                  Ok
                </button>
              </mat-select>
            </ng-container>

            <ng-container *ngIf="isEdit">
              <label class="quicksand-normal-label"
                >Day
                <span class="required-field">*</span>
              </label>
              <input
                type="text"
                nbInput
                formControlName="days"
                readonly
                class="text-capitalize disabled-input"
              />
            </ng-container>
          </div>
        </div>

        <div class="col-md-12">
          <div formArrayName="periods">
            <div
              *ngFor="let opts of options.controls; let i = index"
              [formGroupName]="i"
            >
              <div class="row">
                <div class="col-md-11" [ngClass]="i !== 0 ? 'mt-3' : ''">
                  <div class="row">
                    <div class="col-md-4">
                      <label
                        class="label-color form-control-label quicksand-normal-label"
                        >Title
                        <span class="required-field">*</span>
                      </label>
                      <input
                        type="text"
                        nbInput
                        formControlName="title"
                        placeholder="Enter Title"
                      />
                    </div>
                    <div class="col-md-4">
                      <label
                        class="label-color form-control-label quicksand-normal-label"
                        >Start Time
                        <span class="required-field">*</span>
                      </label>

                      <input
                        nbInput
                        type="text"
                        [nbTimepicker]="timepicker"
                        formControlName="start"
                        *ngIf="!isEdit"
                      />

                      <input
                        nbInput
                        type="text"
                        [nbTimepicker]="timepicker"
                        formControlName="start"
                        *ngIf="isEdit"
                      />

                      <nb-timepicker
                        #timepicker="nbTimepicker"
                        twelveHoursFormat
                        (onSelectTime)="!isEdit ? changeValue($event, i) : null"
                      ></nb-timepicker>
                    </div>
                    <div class="col-md-4">
                      <label
                        class="label-color form-control-label quicksand-normal-label"
                        >End Time
                        <span class="required-field">*</span>
                      </label>

                      <input
                        nbInput
                        type="text"
                        [nbTimepicker]="timepickerEnd"
                        formControlName="end"
                        *ngIf="!isEdit"
                      />

                      <input
                        nbInput
                        type="text"
                        [nbTimepicker]="timepickerEnd"
                        formControlName="end"
                        *ngIf="isEdit"
                      />

                      <nb-timepicker
                        #timepickerEnd="nbTimepicker"
                        twelveHoursFormat
                      ></nb-timepicker>
                    </div>
                  </div>
                </div>
                <div class="col-md-1" [ngClass]="i !== 0 ? 'mt-5' : ''">
                  <div
                    class="delete-option cursor-pointer ml-1"
                    [ngClass]="i !== 0 ? 'mt-2' : ''"
                    *ngIf="i !== 0"
                    (click)="deleteOptions(i)"
                  >
                    <img
                      src="/assets/icons/delete.svg"
                      alt="delete-question"
                      height="20"
                      width="20"
                    />
                  </div>
                </div>
              </div>
            </div>

            <label class="cursor-pointer mt-3" (click)="addOptions()">
              <img
                src="/assets/icons/add-options.svg"
                alt="add-options"
                height="20"
                width="20"
                class="cursor-pointer"
              />
              <label
                class="quicksand-bold-label view-delete-label ml-2 add-options-label cursor-pointer"
                >Add Period</label
              >
            </label>
          </div>
        </div>
      </div>
    </form> -->
    </div>

    <div class="modal-footer d-flex justify-content-end">
      <ng-container *ngIf="isEdit">
        <button
          nbButton
          class="add-school-periods-btn add-new-school-period-button text-capitalize quicksand-bold-label text-white mr-2"
          (click)="openApplyToAllModal()"
          *ngIf="
            router.url.includes('teacher')
              ? teacherSchoolPeriods && teacherSchoolPeriods[0]?.school_periods?.length > 0
              : school && school?.school_periods?.length > 0
          "
        >
          Apply to all days
        </button>
      </ng-container>
      <button
        nbButton
        class="bg-white cancel-btn text-capitalize quicksand-bold-label mr-2"
        (click)="modalService.dismissAll(); addSchoolPeriodForm.reset(); loading = false"
      >
        Cancel
      </button>
      <button
        nbButton
        class="add-school-periods-btn text-capitalize quicksand-bold-label text-white save-and-next-btn"
        [disabled]="addSchoolPeriodForm.invalid && options.length === 0"
        (click)="router.url.includes('teacher') ? addTeacherPeriod(isEdit ? true : false) : addSchoolPeriod(isEdit ? true : false)"
        style="background-color: #27b24a !important"
      >
        Save
      </button>
    </div>
  </div>
</ng-template>

<ng-template #dialog let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-body>
      <div class="text-center">
        <img src="/assets/icons/featured icon.svg" alt="delete-icon" loading="lazy" />
        <br />

        <label class="label-delete-lesson-plan mt-2 quicksand-bold-label" *ngIf="!router.url.includes('teacher')"
          ><ng-container *ngIf="school && school.school_periods.length > 0"
            >You have added instructional periods for only {{ school?.school_periods?.length }} working days</ng-container
          >
          <ng-container *ngIf="school && school.school_periods.length === 0"
            >You have not added instructional periods for your school</ng-container
          >
        </label>

        <label class="label-delete-lesson-plan mt-2 quicksand-bold-label" *ngIf="router.url.includes('teacher')"
          ><ng-container *ngIf="teacherSchoolPeriods && teacherSchoolPeriods[0]?.school_periods?.length > 0"
            >You have added instructional periods for only {{ teacherSchoolPeriods[0]?.school_periods.length }} working days</ng-container
          >
          <ng-container *ngIf="teacherSchoolPeriods && teacherSchoolPeriods.length === 0"
            >You have not added instructional periods for you.</ng-container
          >
        </label>
        <br />
        <label class="delete-lesson-plan-confirmation quicksand-bold-label">Are you sure you want to continue with this ?</label>
      </div>
      <div class="d-flex">
        <button
          nbButton
          class="delete-lesson-plan bg-white m-2 w-100 quicksand-bold-label text-capitalize"
          (click)="ref.close(); spinner.hide()"
        >
          No
        </button>
        <button
          nbButton
          color="warn"
          class="delete-lesson-plan add-school-periods-btn text-white m-2 w-100 quicksand-bold-label text-capitalize"
          (click)="router.url.includes('teacher') ? saveTeacherPeriods() : submit()"
          style="border-color: transparent !important"
        >
          Yes
        </button>
      </div>
    </nb-card-body>
  </nb-card>
</ng-template>

<ng-template #selectBellSheduleTypeModal let-data let-ref="dialogRef">
  <nb-card class="select-type-modal" style="border-radius: 12px; margin: 0px">
    <nb-card-body style="padding: 0rem 1rem 0rem 1rem">
      <div class="text-center" style="margin-top: 12px">
        <img src="/assets/icons/featured icon.svg" alt="delete-icon" loading="lazy" />
        <span class="icon-close-classroom-modal d-block cursor-pointer float-right" (click)="ref.close()">
          <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
        </span>
      </div>
      <div class="mt-2">
        <h6 class="quicksand-bold-label">Please select bell schedule type</h6>
        <mat-select placeholder="Please Select Bell Shedule" class="select-bell-shedule w-100" [(ngModel)]="selectedType">
          <mat-option value="1" class="quicksand-bold-label select-range select-school-name"
            >Add Periods to Current Bell Schedule Version</mat-option
          >
          <mat-option value="2" class="quicksand-bold-label select-range select-school-name">Add new Bell Schedule Version</mat-option>
        </mat-select>
      </div>
      <button
        nbButton
        color="warn"
        class="delete-lesson-plan add-school-periods-btn text-white mt-4 w-100 quicksand-bold-label text-capitalize"
        [disabled]="!selectedType"
        (click)="openModalAsPerSelectedType(); ref.close()"
      >
        Done
      </button>
    </nb-card-body>
  </nb-card>
</ng-template>

<!-- Select School Bell Schedules Modal -->
<ng-template #selectBellSchedules let-modal>
  <div class="add-classroom-modal">
    <div class="modal-header d-flex justify-content-between align-items-center w-100">
      <div class="d-flex align-items-center">
        <span class="icon-add-classroom">
          <nb-icon icon="plus-outline"></nb-icon>
        </span>
        <h6 class="add-clasroom-text quicksand-bold-label m-0">Select Bell Schedules</h6>
      </div>

      <span class="icon-close-classroom-modal d-block cursor-pointer" (click)="isModal = false; modalService.dismissAll(modalRef)">
        <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
      </span>
    </div>

    <div class="modal-body">
      <mat-label class="quicksand-bold-label">Select School</mat-label>
      <mat-select
        placeholder="Please Select School"
        (selectionChange)="getSchoolBellSchedules($event.value)"
        class="select-bell-shedule w-100 mt-2"
        [(ngModel)]="currentSchool"
        [formControl]="schoolCtrl"
      >
        <mat-option class="quicksand-bold-label select-range select-school-name">
          <ngx-mat-select-search
            [formControl]="schoolFilterCtrl"
            placeholderLabel="Find school..."
            noEntriesFoundLabel="'no matching school found'"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option
          class="quicksand-bold-label select-range select-school-name"
          *ngFor="let school of filteredSchool | async; let i = index"
          [value]="school"
        >
          {{ school?.name }}
        </mat-option>
      </mat-select>

      <div class="form-group mt-3" *ngIf="currentSchool && selectedSchoolBellSchedules?.length > 0">
        <label class="quicksand-bold-label"> Select Bell Schedule Version <span class="required-field">*</span> </label>
        <br />

        <mat-select
          placeholder="Please Select Bell Schedule"
          (selectionChange)="getCurrentBellShedule($event.value, true)"
          class="select-bell-shedule"
          [(ngModel)]="currentSelectedBellSchedule"
        >
          <mat-option
            *ngFor="let bellShedule of selectedSchoolBellSchedules; let i = index"
            [value]="bellShedule"
            class="quicksand-bold-label select-range select-school-name"
            ><span *ngIf="bellShedule?.name">
              {{ bellShedule?.name }}
            </span>
            <span *ngIf="!bellShedule?.name">Version {{ i + 1 }}</span></mat-option
          >
        </mat-select>
      </div>

      <div class="mt-3 text-center quicksand-bold-label no-schedule" *ngIf="currentSchool && selectedSchoolBellSchedules?.length === 0">
        No school bell schedule found!
      </div>

      <div *ngIf="currentSelectedBellSchedule && currentSchool">
        <div class="row" *ngIf="currentSelectedBellSchedule?.school_id">
          <div class="col-md-4" *ngFor="let schoolPeriod of currentSelectedBellSchedule?.bell_schedule">
            <nb-card class="border-0">
              <nb-card-header class="quicksand-bold-label text-uppercase school-period-card-header"
                >{{ schoolPeriod.day | titlecase }}
              </nb-card-header>
              <nb-card-body style="line-height: 1.5rem !important">
                <div
                  class="row mt-2"
                  *ngFor="let period of schoolPeriod.periods; let i = index"
                  [ngClass]="
                    !period?.title?.toLowerCase().includes('period') && !period?.title?.toLowerCase().includes('block') ? 'title-break' : ''
                  "
                >
                  <div class="col-md-4 quicksand-bold-label">
                    {{ period.title | titlecase }}
                  </div>
                  <div class="col-md-4 quicksand-bold-label">
                    {{ period?.start | date: 'h:mm a' }}
                  </div>
                  <div class="col-md-4 quicksand-bold-label">
                    {{ period?.end | date: 'h:mm a' }}
                  </div>
                </div>
              </nb-card-body>
            </nb-card>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer d-flex justify-content-end">
      <button
        nbButton
        class="add-school-periods-btn add-new-school-period-button text-capitalize quicksand-bold-label text-white mr-2"
        (click)="addAllBellScheduleToCurrentSchool()"
        [disabled]="!currentSelectedBellSchedule || !currentSchool || selectedSchoolBellSchedules?.length === 1"
        style="width: fit-content"
      >
        Copy multiple Bell Schedules
      </button>
      <button
        nbButton
        class="bg-white cancel-btn text-capitalize quicksand-bold-label mr-2"
        (click)="isModal = false; modalService.dismissAll(modalRef)"
      >
        Cancel
      </button>
      <button
        nbButton
        [disabled]="!currentSelectedBellSchedule || !currentSchool"
        class="add-school-periods-btn add-new-school-period-button text-capitalize quicksand-bold-label text-white mr-2"
        (click)="addBellScheduleToCurrentSchool()"
      >
        Add Bell Schedule
      </button>
    </div>
  </div>
</ng-template>
<!-- update bell schedule name modal -->
<ng-template #editBellScheduleName>
  <div class="text-center">
    <img src="/assets/icons/add-options.svg" alt="delete-icon" height="50" loading="lazy" />
    <br />
    <label class="label-delete-lesson-plan mt-2 quicksand-bold-label">Update Bell Schedule Name</label>
  </div>
  <div class="form-group mt-3">
    <label class="quicksand-bold-label">Name of bell schedule <span class="required-field">*</span></label>
    <br />
    <input nbInput type="text" class="w-100" placeholder="Enter name of bell schedule" [(ngModel)]="bellScheduleName" />
  </div>
  <div class="d-flex">
    <button
      nbButton
      class="delete-lesson-plan bg-white bg-white-dark-mode m-2 w-100 quicksand-bold-label text-capitalize"
      (click)="matDialog.closeAll()"
    >
      Cancel
    </button>
    <button
      nbButton
      color="warn"
      class="delete-lesson-plan add-school-periods-btn text-white m-2 w-100 quicksand-bold-label text-capitalize"
      (click)="updateBellScheduleName()"
    >
      Update
    </button>
  </div>
</ng-template>
<!-- add new schedule form -->
<ng-template #newScheduleForm>
  <form [formGroup]="addSchoolPeriodForm">
    <div class="row" [ngClass]="analyticsService.currentTheme === 'material-dark' ? 'dark-theme' : ''">
      <div class="col-md-12">
        <div class="form-group" *ngIf="(!isEdit && selectedType === '2') || manageSchoolYear">
          <label class="quicksand-normal-label label-color">Name of Bell Schedule </label>
          <input type="text" nbInput formControlName="name" placeholder="Please Enter Name" *ngIf="!isEdit" />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <ng-container *ngIf="!isEdit || manageSchoolYear">
            <label class="quicksand-normal-label label-color">Select Days <span class="required-field">*</span></label>
            <mat-select multiple #sl formControlName="days" placeholder="Select Weekdays">
              <mat-option
                *ngFor="let day of weekDays"
                [value]="day"
                class="margin-filter-user select-range quicksand-bold-label select-school-name"
                >{{ day | titlecase }}</mat-option
              >
              <button
                (click)="sl.close()"
                mat-raised-button
                class="float-right m-1 apply-button text-capitalize text-white quicksand-bold-label"
              >
                Ok
              </button>
            </mat-select>
          </ng-container>

          <ng-container *ngIf="isEdit">
            <label class="quicksand-normal-label"
              >Day
              <span class="required-field">*</span>
            </label>
            <input type="text" nbInput formControlName="days" readonly class="text-capitalize disabled-input" />
          </ng-container>
        </div>
      </div>

      <div class="col-md-12">
        <label class="span-label mb-3"
          >You must use either the word "Period" or "Block" in the title to designate it as an instructional period!</label
        >
        <div formArrayName="periods">
          <div *ngFor="let opts of options.controls; let i = index" [formGroupName]="i">
            <div class="row">
              <div class="col-md-11" [ngClass]="i !== 0 ? 'mt-3' : ''">
                <div class="row">
                  <div class="col-md-4">
                    <label class="label-color form-control-label quicksand-normal-label"
                      >Title
                      <span class="required-field">*</span>
                    </label>
                    <input type="text" nbInput formControlName="title" placeholder="Enter Title" />
                  </div>
                  <div class="col-md-4">
                    <label class="label-color form-control-label quicksand-normal-label"
                      >Start Time
                      <span class="required-field">*</span>
                    </label>

                    <input nbInput type="text" [nbTimepicker]="timepicker" formControlName="start" *ngIf="!isEdit" readonly />

                    <input nbInput type="text" [nbTimepicker]="timepicker" formControlName="start" *ngIf="isEdit" readonly />

                    <nb-timepicker
                      #timepicker="nbTimepicker"
                      twelveHoursFormat
                      (onSelectTime)="!isEdit ? changeValue($event, i) : null"
                    ></nb-timepicker>
                  </div>
                  <div class="col-md-4">
                    <label class="label-color form-control-label quicksand-normal-label"
                      >End Time
                      <span class="required-field">*</span>
                    </label>

                    <input nbInput type="text" [nbTimepicker]="timepickerEnd" formControlName="end" *ngIf="!isEdit" readonly />

                    <input nbInput type="text" [nbTimepicker]="timepickerEnd" formControlName="end" *ngIf="isEdit" readonly />

                    <nb-timepicker #timepickerEnd="nbTimepicker" twelveHoursFormat></nb-timepicker>
                  </div>
                </div>
              </div>
              <div class="col-md-1" [ngClass]="i !== 0 ? 'mt-5' : ''">
                <div
                  class="delete-option cursor-pointer ml-1 hover-effect"
                  [ngClass]="i !== 0 ? 'mt-2' : ''"
                  *ngIf="i !== 0"
                  (click)="deleteOptions(i)"
                >
                  <img src="/assets/icons/delete.svg" alt="delete-question" height="20" width="20" />
                </div>
              </div>
            </div>
          </div>

          <label class="cursor-pointer mt-3" (click)="addOptions()">
            <img src="/assets/icons/add-options.svg" alt="add-options" height="20" width="20" class="cursor-pointer" />
            <label class="quicksand-bold-label view-delete-label ml-2 add-options-label cursor-pointer">Add Period</label>
          </label>
        </div>
      </div>
    </div>
  </form>
</ng-template>
